var SubscribeCommentsAction = React.createClass({
  propTypes: {
    solutionID: React.PropTypes.string.isRequired,
    defaultEmailAddress: React.PropTypes.string
  },
  getInitialState() {
    return {
      isOpen: false,
      isSubscribed: false,
      emailAddress: "",
      errorMsg: ""
    }
  },
  componentDidMount() {
    let url = `${Config.contextPath}/controller/status/mysubscriptions/`;
    let data = { solutionID: this.props.solutionID,
     SToken: Config.csrf.value };

    $.post(url, data)
      .done(this.handleResponse);
  },
  handleResponse(r) {
    this.setState({isSubscribed: r.isSubscribed,
        emailAddress: r.emailAddress || this.props.defaultEmailAddress,
        isOpen: false });
  },
  emailChanged(e) {
    this.setState({emailAddress: e.target.value});
  },
  confirmClicked(e) {
    e.preventDefault();

    let url, data;

    if (this.state.isSubscribed) {
      url = `${Config.contextPath}/controller/delete/mysubscriptions/`;
      data = { solutionID: this.props.solutionID,
       SToken: Config.csrf.value };
    } else {
      if (!this.validateForm()) {
        return;
      }

      url = `${Config.contextPath}/controller/add/mysubscriptions/`;
      data = {
        solutionID: this.props.solutionID,
        emailAddress: this.state.emailAddress,
        SToken: Config.csrf.value
      };
    }

    $.post(url, data)
      .done(this.handleResponse);
  },
  validateForm() {
    let msg = "";

    let emailPattern = /^([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,};?\s*)+$/;
    if (!emailPattern.test(this.state.emailAddress)) {
      msg = Labels.getLabel("Invalid email address");
    }

    this.setState({errorMsg: msg});
    return !msg.length;
  },
  toggleClicked(e) {
    if (this.state.isOpen) {
      this.setState({isOpen: false});
      $(document).off("click.ra.dropdown");
    } else {
      this.setState({isOpen: true});
      $(document).on("click.ra.dropdown", this.pageClicked);
    }
  },
  pageClicked(e) {
    if (e.target == this.refs.popup
     || this.refs.popup.contains(e.target)
     || e.target == this.refs.toggle) {
      return;
    }

    this.toggleClicked(e);
  },
  getErrorMessage() {
    if (!this.state.errorMsg.length) {
      return;
    }

    return (
      <div className="alert alert-danger">
        <span className="glyphicon glyphicon-exclamation-sign"></span>
        <strong>{" " + Labels.getLabel("Error")}:</strong>{" " + this.state.errorMsg}
      </div>
    );
  },
  getSubscribeForm() {
    return (
      <div>
        {this.getErrorMessage()}

        <p>{Labels.getLabel("Enter your email address to receive notifications when comments are added.")}</p>

        <form>
          <div className="input-group">
            <input type="text" className="form-control" placeholder="Email Address" onChange={this.emailChanged} value={this.state.emailAddress} />
            <span className="input-group-btn">
              <button className="btn btn-default" type="submit" onClick={this.confirmClicked}><span className="glyphicon glyphicon-ok"></span></button>
            </span>
          </div>
        </form>

      </div>
    );
  },
  getUnsubscribeForm() {
    return (
      <div>
        <p>Turn off notifications for this solution sent to <span className="text-success">{this.state.emailAddress}</span>?</p>

        <div className="text-right">
          <button className="btn btn-default" type="button" onClick={this.confirmClicked}><span className="glyphicon glyphicon-ok"></span></button>
        </div>
      </div>
    );
  },
  render() {
    let label = this.state.isSubscribed ? Labels.getLabel("Unsubscribe") : Labels.getLabel("Subscribe");

    return (
      <div className={"dropdown " + (this.state.isOpen ? " open" : "")}>
        <button type="button" className="btn btn-sm btn-default" ref="toggle" onClick={this.toggleClicked}>
          {label + " "}
          <span className="caret"></span>
        </button>
        <div className="dropdown-menu dropdown-menu-right -no-list" ref="popup">
          {this.state.isSubscribed ? this.getUnsubscribeForm() : this.getSubscribeForm()}
        </div>
      </div>
    );
  }
});